import clsx from "clsx"

export type ShippingCostsProps = {
  freeShipping: boolean | undefined
}

export const ShippingCosts = ({ freeShipping }: ShippingCostsProps) => {
  return (
    <div
      className={clsx("text-np-green leading-tight text-pretty", {
        "font-semibold": freeShipping,
      })}
    >
      {freeShipping ? "Versand gratis (DE)" : "zzgl. Versand"}
    </div>
  )
}
